import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../store';

const selectRoot = ({ currentUser }: RootState) => currentUser;

export const selectUsersByPhone = createSelector(
    selectRoot,
    ({ currentUser }) => currentUser,
);
